import { Host, h } from '@stencil/core';
export class RuntimeBaseCell {
  constructor() {
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("div", { class: "runtime-base-cell__value" }, h("slot", { name: "value" })), h("div", { class: "runtime-base-cell__error" }, h("slot", { name: "error" }))));
  }
  static get is() { return "pes-runtime-base-cell"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-runtime-base-cell.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-runtime-base-cell.css"]
    };
  }
  static get elementRef() { return "el"; }
}
